export default __webpack_public_path__ + "static/media/mysms.dd66d072.mp4";